




















import { defineComponent } from 'vue';
import Pill from '../../../shared/components/Pill.vue';
import { useSearchFilter } from '../../composables/global_search/useSearchFilter';
import { SearchFilterBucket } from '../../../shared/models/responses/search/findGeneric.response';
import { useSearchExecution } from '../../composables/global_search/useSearchExecution';
import { docTypes } from '../../../shared/enums/docTypes';
import { iconClassEnum } from '../../../shared/enums/iconClassEnum';
import ScrollShadowHorizontal from '../../../shared/components/ScrollShadowHorizontal.vue';

export default defineComponent({
  name: 'GlobalSearchFilter',
  components: { ScrollShadowHorizontal, Pill },
  setup() {
    const { activeFilter, filters, setActiveFilter, getFilterLabel } = useSearchFilter();
    const { initializeSearch } = useSearchExecution();

    const handleFilterSelect = (filter: SearchFilterBucket) => {
      setActiveFilter(filter.key as docTypes);
      initializeSearch();
    };

    return {
      activeFilter,
      filters,
      getFilterLabel,
      handleFilterSelect,
      iconClassEnum,
    };
  },
});
